// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HelpText: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M13.225.75h-10.5c-.964 0-1.75.786-1.75 1.725v7.85c0 .965.786 1.726 1.75 1.726H5.35v2.297c0 .268.301.425.523.265l3.415-2.562h3.938c.963 0 1.75-.786 1.75-1.725v-7.85c-.001-.94-.764-1.726-1.751-1.726zm.9 9.625a.878.878 0 01-.875.875H9.31a.875.875 0 00-.526.175L6.25 13.328v-1.64a.437.437 0 00-.438-.438H2.75a.878.878 0 01-.875-.875V2.5c0-.481.393-.875.875-.875h10.5c.48 0 .875.394.875.875v7.875z" />
        </svg>
    );
};

export default React.memo(HelpText);
